<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023-2024 (original work) Open Assessment Technologies SA ;
    import Icon from '../icon/Icon.svelte';
    export let title = '';
    export let href;
    export let target;
    export let iconBefore;
    export let iconAfter;
    export let ariaLabel = false;
    export let disabled;
    export let skin;

    const skins = {
        link: 'link',
        button: 'button'
    };

    if (!skins[skin]) {
        skin = skins.link;
    }

    function handleClick(e) {
        if (!href) {
            e.preventDefault();
        }
    }
</script>

<style>
    .button-link {
        --btnlnk-color-text: var(--color-text-default);
        --btnlnk-color-text-disabled: var(--color-text-disabled);
        --btnlnk-color-bg-hover: var(--color-bg-actionable-secondary-hover);
        --btnlnk-color-focus-border: var(--color-border-focus);

        display: inline-flex;
        align-items: center;
        gap: 1rem;

        &[aria-disabled='true'] {
            color: var(--btnlnk-color-text-disabled);
            cursor: not-allowed;
        }

        &.skin-button {
            text-decoration: none;
            text-transform: uppercase;
            font-size: var(--fontsize-body-xs);
            font-weight: 700;
            border-radius: var(--radius-pill);
            line-height: 5rem;
            padding-inline: 1.5rem;

            @add-mixin outline-focus 0rem;
            &:focus-visible::after {
                border-radius: var(--radius-pill);
                border-color: var(--btnlnk-color-focus-border);
            }

            &:not([aria-disabled='true']) {
                &:active,
                &:focus {
                    color: var(---btnlnk-color-text);
                }
                &:hover,
                &:focus-visible {
                    color: var(---btnlnk-color-text);
                    background-color: var(--btnlnk-color-bg-hover);
                }
            }
        }
    }

    :global(.inverted) .button-link {
        --btnlnk-color-text: var(--color-text-default-inverted);
        --btnlnk-color-text-disabled: var(--color-text-disabled-inverted);
        --btnlnk-color-bg-hover: var(--color-bg-actionable-secondary-hover-inverted);
        --btnlnk-color-focus-border: var(--color-border-focus-inverted);
    }
</style>

<a
    class="button-link"
    class:skin-button={skin === skins.button}
    href={href || '#'}
    {target}
    on:click={handleClick}
    on:click
    on:keypress
    aria-label={ariaLabel ? ariaLabel : title}
    aria-disabled={disabled}>
    {#if iconBefore}
        <Icon name={iconBefore} />
    {/if}
    {title}
    {#if iconAfter}
        <Icon name={iconAfter} />
    {/if}
</a>
